import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="nav-menu"
export default class extends Controller {
  static targets = ["menu", "icon"]
  static values = {
    expanded: { type: Boolean, default: false },
    id: String
  }

  connect() {
    // Restore state from localStorage if available
    const savedState = localStorage.getItem(`nav_menu_${this.idValue}`)
    if (savedState === 'true') {
      this.expandedValue = true
      this.showMenu()
    } else {
      this.hideMenu()
    }
  }

  toggle() {
    this.expandedValue = !this.expandedValue
    this.expandedValue ? this.showMenu() : this.hideMenu()
    
    // Save state to localStorage
    localStorage.setItem(`nav_menu_${this.idValue}`, this.expandedValue)
  }

  showMenu() {
    this.menuTarget.classList.remove('hidden')
    if (this.hasIconTarget) {
      this.iconTarget.classList.remove('transform', 'rotate-0')
      this.iconTarget.classList.add('transform', 'rotate-180')
    }
  }

  hideMenu() {
    this.menuTarget.classList.add('hidden')
    if (this.hasIconTarget) {
      this.iconTarget.classList.remove('transform', 'rotate-180')
      this.iconTarget.classList.add('transform', 'rotate-0')
    }
  }
}
